import React from 'react'

const Loading = () => (
  <div className="loader-container d-flex align-items-center justify-content-center loading2">
    <div className="center-screen pos-center">
      <div className='loaderDiv'> </div>
    </div>
  </div>
)

export default Loading
